import { useTranslate } from '@refinedev/core';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Divider, Flex, Typography, theme } from 'antd';

/**
 * Honest label under a phone replica: the preview is a simulation, not a
 * screenshot. Ships with every preview panel, so no surface can quietly
 * present itself as the real app.
 */
export const MobilePreviewDisclaimer = () => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <>
      <Divider style={{ marginBlock: token.marginSM }} />
      <Flex gap={token.marginXS} align="flex-start">
        <InfoCircleOutlined
          style={{ color: token.colorTextTertiary, marginTop: 4 }}
        />
        <Typography.Text type="secondary">
          {t('base.mobile_preview.disclaimer.text')}
        </Typography.Text>
      </Flex>
    </>
  );
};
